import { useEffect, useState } from "react";
import RegularInfBox from "../../Molecules/RegularInfBox/RegularInfBox";
import "./HomeSolutonsSection.scss";
import caracteristicas from "../../../assets/img/caracteristicas.png";
import SolutionsPattern from "../../Molecules/SolutionsPattern/SolutionsPattern";
import rastreo_icon from "../../../assets/img/rastreo_icon.svg";
import mantenimiento_icon from "../../../assets/img/mantenimiento_icon.svg";
import combustible_icon from "../../../assets/img/combustible_icon.svg";
import content from "../../Pages/Home/content";
import solutionsVariants from "../../../Services/variants/solutionsVariants";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

function HomeCaracteristicasSection() {
	const [ref, inView] = useInView();
	const [animate, setAnimate] = useState(false);
	const {language} = useLanguageCtx();

	useEffect(() => {
		if (inView) {
			if (!animate) {
				setAnimate(true);
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inView]);

	return (
		<div className="homeSolutionsSection-container">
			<div className="max-width homeSolutionsSection-grid-design">
				<div className="homeSolutionsSection-header-container">
					<RegularInfBox
						yellowTitle={content[language].solucionesYellowTitle}
						boldTitle={content[language].solucionesBoldText}
						boldContent={content[language].solucionesBoldContent}
						buttonContent={content[language].solucionesButtonContent}
						buttonType="button light-blue"
					/>
				</div>
				<div
					className="homeSolutionsSection--soutions_pattern-container grid full-column"
					ref={ref}
				>
					<motion.div
						className="homeSolutionsSection-first-solution"
						variants={solutionsVariants}
						initial="hidden"
						animate={animate ? "visible" : ""}
					>
						<SolutionsPattern
							icon={rastreo_icon}
							title={content[language].solucion_1Title}
							content={content[language].solucion_1Content}
							linkRoute="/solutions/g-evolution"
						/>
					</motion.div>
					<motion.div
						className="homeSolutionsSection-second-solution"
						variants={solutionsVariants}
						initial="hidden"
						custom={0.5}
						animate={animate ? "visible" : ""}
					>
						<SolutionsPattern
							icon={mantenimiento_icon}
							title={content[language].solucion_2Title}
							content={content[language].solucion_2Content}
							linkRoute="/solutions/aplicaciones-moviles"
						/>
					</motion.div>
					<motion.div
						className="homeSolutionsSection-third-solution"
						variants={solutionsVariants}
						initial="hidden"
						custom={1}
						animate={animate ? "visible" : ""}
					>
						<SolutionsPattern
							icon={combustible_icon}
							title={content[language].solucion_3Title}
							content={content[language].solucion_3Content}
							linkRoute="/solutions/telematica"
						/>
					</motion.div>
				</div>
			</div>
			<div className="homeSolutionsSection-geofence-img-container">
				<img
					src={caracteristicas}
					alt="Dispositivos"
					className="all-width-height geofence-img aspect-ratio contain"
				/>
			</div>
		</div>
	);
}

export default HomeCaracteristicasSection;
